module.exports = __webpack_public_path__ + "static/media/crew-polly.dfb56141.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightPage/img/crew-polly.png
// module id = 1001
// module chunks = 0